"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RightNavMobile = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const SiteNavMobileLinks_1 = require("../sitenav/SiteNavMobileLinks");
const Styled = styled_components_1.default.div `
	display: flex;
	justify-content: flex-end;
	height: 100%;
	overflow: hidden;
	margin-left: 12px;
`;
const RightNavMobile = (props) => {
    return (react_1.default.createElement(Styled, { id: "rightNav", key: "right-nav-mobile", className: "right-nav-mobile" },
        react_1.default.createElement(SiteNavMobileLinks_1.SiteNavMobileLinks, Object.assign({}, props, { topOffset: props.topOffset }))));
};
exports.RightNavMobile = RightNavMobile;
//# sourceMappingURL=RightNavMobile.js.map